<template>
    <header
        class="welcome-navbar sticky top-0 z-50 transition-all duration-300"
        :class="scrolled ? 'welcome-navbar--scrolled' : ''"
    >
        <nav class="welcome-navbar__inner mx-auto max-w-7xl px-3 sm:px-6 lg:px-8" dir="rtl">
            <router-link :to="{ name: 'welcome' }" class="welcome-navbar__brand" aria-label="البرمجة مع غنيم">
                <img
                    :src="logoSrc"
                    alt="شعار البرمجة مع غنيم"
                    class="welcome-navbar__logo-img"
                />
            </router-link>

            <div class="welcome-navbar__actions">
                <div class="welcome-navbar__links">
                    <template v-for="link in navLinks">
                        <a
                            v-if="link.href"
                            :key="link.label"
                            :href="link.href"
                            class="welcome-navbar__link"
                        >{{ link.label }}</a>
                        <router-link
                            v-else-if="link.route"
                            :key="link.label"
                            :to="{ name: link.route }"
                            class="welcome-navbar__link"
                        >{{ link.label }}</router-link>
                    </template>
                </div>

                <div class="welcome-navbar__auth">
                    <router-link :to="{ name: 'login' }" class="welcome-navbar__btn welcome-navbar__btn--outline">
                        <span class="welcome-navbar__label-full">تسجيل الدخول</span>
                        <span class="welcome-navbar__label-short">الدخول</span>
                    </router-link>

                    <router-link :to="{ name: 'register' }" class="welcome-navbar__btn welcome-navbar__btn--primary">
                        <span class="welcome-navbar__label-full">حساب جديد</span>
                        <span class="welcome-navbar__label-short">تسجيل</span>
                    </router-link>
                </div>

                <button
                    type="button"
                    class="welcome-navbar__menu-btn"
                    :aria-expanded="open ? 'true' : 'false'"
                    aria-label="القائمة"
                    @click="open = !open"
                >
                    <lucide-icon :name="open ? 'X' : 'Menu'" class="h-5 w-5" />
                </button>
            </div>
        </nav>

        <transition name="welcome-navbar-panel">
            <div v-if="open" class="welcome-navbar__panel sm:hidden" dir="rtl">
                <template v-for="link in navLinks">
                    <a
                        v-if="link.href"
                        :key="'m-' + link.label"
                        :href="link.href"
                        class="welcome-navbar__panel-link"
                        @click="closeMenu"
                    >{{ link.label }}</a>
                    <router-link
                        v-else-if="link.route"
                        :key="'m-' + link.label"
                        :to="{ name: link.route }"
                        class="welcome-navbar__panel-link"
                        @click="closeMenu"
                    >{{ link.label }}</router-link>
                </template>
            </div>
        </transition>
    </header>
</template>

<script>
import LucideIcon from './LucideIcon.vue';
import { navLinks, LOGO_SRC } from './landing-data';

export default {
    name: 'WelcomeNavbar',
    components: { LucideIcon },
    data() {
        return {
            open: false,
            scrolled: false,
            navLinks,
            logoSrc: LOGO_SRC,
        };
    },
    mounted() {
        this.onScroll();
        window.addEventListener('scroll', this.onScroll);
        document.addEventListener('click', this.onDocumentClick);
    },
    beforeDestroy() {
        window.removeEventListener('scroll', this.onScroll);
        document.removeEventListener('click', this.onDocumentClick);
    },
    methods: {
        onScroll() {
            this.scrolled = window.scrollY > 16;
        },
        closeMenu() {
            this.open = false;
        },
        onDocumentClick(event) {
            if (!this.open) {
                return;
            }
            const navbar = this.$el;
            if (navbar && !navbar.contains(event.target)) {
                this.open = false;
            }
        },
    },
};
</script>
